import { useEffect, useState } from 'react'
import Styles from './Progress.module.scss'
import UncontrolledTransition from '@onepercentio/one-ui/components/UncontrolledTransition'
import { TransitionAnimationTypes } from '@onepercentio/one-ui/components/Transition'
import Text from 'openspace/components/Text'
import { LPTypo } from 'containers/OneUIProvider/OneUIProvider.data'
import LoaderDotsIndicator from '@onepercentio/one-ui/components/LoaderDotsIndicator'

type AvailableHandles = 'kyc' | 'create_offer' | 'step_approval'
type HandleEffect = (stepMessage: string, isAt: number) => void

/**
 * This module provides a way to reflect async
 * processes steps throught different parts of the application
 */
class Progress {
  handleCallbacks: {
    [k in AvailableHandles]: HandleEffect[]
  } = {
    kyc: [],
    create_offer: [],
    step_approval: [],
  }
  /**
   *
   * @param handle The handle to update
   * @param stepMessage The message for the current step
   * @param isAt The current step
   */
  dispatchHandle(handle: AvailableHandles, stepMessage: string, isAt: number) {
    for (const cb of this.handleCallbacks[handle]) {
      cb(stepMessage, isAt)
    }
  }

  registerHandle(handle: AvailableHandles, effect: HandleEffect) {
    this.handleCallbacks[handle].push(effect)
    return () => {
      this.handleCallbacks[handle] = this.handleCallbacks[handle].filter(
        (registered) => registered !== effect
      )
    }
  }
}

const ProgressDispatcher = new Progress()

export default ProgressDispatcher

export function useProgressUI(handle: AvailableHandles) {
  const [currStep, setCurrStep] = useState<string>('')

  useEffect(() => {
    return ProgressDispatcher.registerHandle(handle, (message: string) => {
      setCurrStep(message)
    })
  }, [])

  return (
    <UncontrolledTransition
      className={Styles.root}
      transitionType={TransitionAnimationTypes.COIN_FLIP}>
      <Text key={currStep || 'empty'} type={LPTypo.P1}>
        {currStep}
        {currStep && <LoaderDotsIndicator dotsCount={3} lockSize />}
      </Text>
    </UncontrolledTransition>
  )
}
